import { render, staticRenderFns } from "./ClassPptThird.vue?vue&type=template&id=6a312d0c&scoped=true&"
import script from "./ClassPptThird.vue?vue&type=script&lang=js&"
export * from "./ClassPptThird.vue?vue&type=script&lang=js&"
import style0 from "./ClassPptThird.vue?vue&type=style&index=0&id=6a312d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a312d0c",
  null
  
)

export default component.exports